export default __webpack_public_path__ + "static/media/hvac_control_01.69d96345.jpg";